/**
 * This file is to map send email action , from and to BE structure, it should contain at least two functions, one that maps
 * from BE to FE structure, and the other one that maps from FE to BE structure
 */
import { ActionEvents, RSSActionEvents } from "assets/js/scenes/automations/containers/editor/EventsConfigs";
import store from "assets/js/store";
import {
	getEdge,
	getEndCoachmarkNode,
	getNextTarget,
	getShadowsForStep,
} from "assets/js/scenes/automations/containers/editor/utils/utils";

const parseBERSSStoreToFE = (automation, mainStep, subStep, targetId) => {
	const events = [];
	events.push({
		id: mainStep.name,
		type: "editorNode",
		position: {
			x: 0,
			y: 0,
		},
		data: {
			name: RSSActionEvents()[0].name,
			desc: RSSActionEvents()[0].desc,
			type: "action",
			tileTitle: "app-automation-editor_events_action-RSS-1_name",
			id: mainStep.name,
			baseId: "rssStore",
			shadows: getShadowsForStep(automation, mainStep.name),
			template_id: subStep.args.template_id,
			rss_urls: subStep.args.rss_urls,
		},
	});
	const links = [];
	if (targetId) {
		links.push(getEdge("custom", mainStep.name, targetId));
	} else {
		const endCoachmark = getEndCoachmarkNode(0, 0);
		events.push(endCoachmark);
		links.push(getEdge("custom", mainStep.name, endCoachmark.id));
	}
	return {
		events: events,
		links: links,
	};
};
const parseFERSSSToreToBE = (
	FEEvent,
	connectedEdges,
	events,
	nextIndex,
	selfIndex
) => {
	let shadows = [];
	let inTos = [];
	if (FEEvent.data.shadows) shadows = [...FEEvent.data.shadows];
	inTos = events
		.filter((e) => e.data.baseId == "loop")
		.filter((e) => e.data.goTo == FEEvent.id);
	if (inTos.length > 0) inTos = inTos.map((e) => `${e.id}_loop`);


	// issue here is that there can only be one template in the flow.
	const emailAPIInFlow = events.find((e) => { return e.id.includes('a6'); });

	return {
		main: [
			{
				steps: [
					{
						name: `${FEEvent.id}`,
						action: "SubAutomation.Call",
						args: {
							sub_automation: FEEvent.id,
						},
						next: "end",
						shadows: shadows,
						inTos: inTos,
					},
				],
			},
		],
		sub: [
			{
				name: FEEvent.id,
				params: [],
				steps: [
					{
						name: `${FEEvent.id}`,
						description: FEEvent.data.actionName,
						action: "RSSItem.Store",
						args: {
							template_id: emailAPIInFlow?.data?.content?.template?.id?.toString() || FEEvent.data?.template_id || "",
							rss_urls: emailAPIInFlow?.data?.rss_urls || FEEvent?.data?.rss_urls || []
						},
						next: getNextTarget(connectedEdges, events),
					},
				],
			},
		],
		reusableSubAutomations: ["emit_next_step"],
	};
};
export { parseBERSSStoreToFE, parseFERSSSToreToBE };
